const Favoruties = () => {
  return (
    <svg width="19" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.588 16.178c.217 1.256-.876 2.046-2.009 1.453 0 0-4.253-2.203-4.211-2.225l-4.25 2.225c-1.134.594-2.225-.198-2.01-1.453 0 0 .791-4.71.824-4.677L.494 8.163c-.917-.89-.499-2.169.767-2.352 0 0 4.742-.707 4.721-.665L8.107.857c.567-1.143 1.917-1.142 2.483 0 0 0 2.14 4.273 2.094 4.266l4.752.688c1.267.183 1.683 1.462.767 2.352 0 0-3.419 3.347-3.426 3.301l.811 4.714Zm-10.492-.62 3.41-1.786c.498-.262 1.188-.261 1.686 0l3.417 1.789-.66-3.785a1.895 1.895 0 0 1 .522-1.597l2.753-2.673-3.806-.556a1.907 1.907 0 0 1-1.365-.987L9.35 2.526 7.644 5.963c-.25.503-.808.907-1.364.987l-3.811.552 2.757 2.677c.404.392.617 1.045.522 1.597l-.652 3.781Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Favoruties;
